import { ApplicationConfig, isDevMode, LOCALE_ID, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalService } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { ValToastService } from '@valamar/val-toast';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { ValAuthInterceptor } from './http-interceptors/val-auth.interceptor';
import { ValCommonHeadersInterceptor } from './http-interceptors/val-common-headers.interceptor';
import { ValUtilsService } from './services/val-utils.service';
import { VrcAccountUtilsService } from './services/vrc-account-utils.service';
import { VrcAuthService } from './services/vrc-auth.service';
import { VrcBrowserStorageService } from './services/vrc-browser-storage.service';
import { VrcConfigService } from './services/vrc-config.service';
import { VrcDataService } from './services/vrc-data.service';
import { VrcStorageService } from './services/vrc-storage.service';
function loggerCallback(logLevel: LogLevel, message: string) {
  // console.log(message);
}
function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: '/auth',
      postLogoutRedirectUri: '/login'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}
function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string> | null>();
  protectedResourceMap.set(environment.scheme + environment.host + environment.port + '/api/v' + environment.version + '/auth/getUserToken', null);
  protectedResourceMap.set(environment.scheme + environment.host + environment.port + '/api/v' + environment.version + '/auth/getApiToken', null);
  protectedResourceMap.set(environment.scheme + environment.host + environment.port + '/api/v' + environment.version + '/auth/getToken', null);
  protectedResourceMap.set(environment.scheme + environment.host + environment.port + '/api/v' + environment.version + '/*', ['api://' + environment.msalConfig.api]);
  protectedResourceMap.set(environment.scheme + environment.crm_host + environment.port + '/api/v' + environment.crmVersion + '/*', ['api://' + environment.msalConfig.api]);
  protectedResourceMap.set(environment.scheme + environment.offer_host + environment.port + '/api/v' + environment.offerVersion + '/*', ['api://' + environment.msalConfig.api]);
  protectedResourceMap.set(environment.scheme + environment.auth_host + environment.port + '/api/v' + environment.authVersion + '/*', ['api://' + environment.msalConfig.api]);
  protectedResourceMap.set(environment.scheme + environment.validation_host + environment.port + '/api/v' + environment.validationVersion + '/*', ['api://' + environment.msalConfig.api]);
  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap,
    strictMatching: true,
  };
}
function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Popup,
    loginFailedRoute: 'login',
    authRequest: { scopes: ['user.read'] }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideZonelessChangeDetection(),
    provideRouter(routes, withViewTransitions()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ValCommonHeadersInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ValAuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    MsalInterceptor,
    ValUtilsService,
    VrcAccountUtilsService,
    VrcAuthService,
    VrcBrowserStorageService,
    VrcConfigService,
    VrcDataService,
    VrcStorageService,
    { provide: LOCALE_ID, useValue: 'hr' },
    ValToastService
  ]
};
